<div class="selected-service-row" [formGroup]="serviceRowForm">
  <div class="service-name">{{ serviceRowForm.get('key')?.value }}</div>
  <div class="service-checkboxes">
    <mat-checkbox formControlName="isActive">{{ 'SERVICES.ISACTIVE' | translate }}</mat-checkbox>
    <mat-checkbox formControlName="isChargeable">{{ 'SERVICES.ISCHARGEABLE' | translate }}</mat-checkbox>
  </div>
  <div class="service-input">
    <mat-form-field>
      <mat-label>{{ 'SERVICES.PLACEMENTID' | translate }}</mat-label>
      <mat-select formControlName="placementId" name="placementId">
        <mat-option></mat-option>
        <mat-option *ngFor="let placementId of placementIdsList" [value]="placementId.key">
          {{ placementId.key }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="service-error" *ngIf="serviceRowForm.errors?.placementIdRequired">{{ 'SERVICES.PLACEMENTID_REQUIRED' | translate }}</div>
<div class="service-error" *ngIf="serviceRowForm.errors?.invalidPlacementId">
  {{ 'SERVICES.PLACEMENTID_INVALID' | translate }}
</div>
<mat-divider></mat-divider>
